export default __webpack_public_path__ + "static/media/close-icn.6a3fca02.svg";